//没有请为空
// let cdn = 'https://cdn.hnztaqkj.com/ztap/oem/td';
let cdn = '/static/oem/xinyuan';

const config = {
  //平台名称
  platformName: '安全教育网络平台',
  entName:"山东欣元安全科技有限公司",
  suffixName:'安全教育网络平台',
  //个人端应用名称（或小程序名称）
  userAppName: '安盛通个人端小程序',
  //企业端应用名称（或小程序名称）
  entAppName: '安盛通企业端',
  platformCode: 'hx',
  //底部版权信息 支持html
  copyright: 'Copyright © 2022 安全教育网络平台 版权所有 备案号:鲁ICP备2022014458号 经营执照 最佳显示分辨率：1920*1080',
  //二维码host路径
  qRCodeHost: 'https://edu.sdxyaqkj.com/qrcode/index',
  //是否开启商城
  includeMall: false,
  enableEntRegister: false,
  enableActivation: false,
  enableQRCodeRegistration: false,
  //是否免费课程
  freeCourse: false,
  isDisplayTitle:true,
  //图片节点，规范请统一放入到项目的 static/img 下 命名请规范
  images: {
    //logo图
    logoImage: cdn + '/img/logo.png',
    //登陆页面图
    loginTopImage: cdn + '/img/login-top-image.jpg',
    //监管登录
    jgLoginTopImage: cdn + '/img/jg-login-top-image.jpg',
    //用户小程序码图片
    userXcxCodeImage: cdn + '/img/userXcxCodeImage.png',
    //个人端简单版本二维码（正方形）
    userXcxCodeSimpleImage:  cdn + '/img/userXcxCodeSimpleImage.png',
    //企业端小程序二维码图片
    enterpriseXcxCodeImage: cdn+'/img/enterpriseXcxCodeImage.jpg',
    //企业端简单版本二维码
    enterpriseXcxCodeSimpleImage: cdn+'/img/enterpriseXcxCodeSimpleImage.png',
    //注册-个人用户注册二维码
    registerUserQRCodeImage: cdn + '/img/registerUserQRCode.jpg',
    //导航 top logo
    navTopLogo: cdn + '/img/zt-nav-top-logo.jpg',
    //客服微信
    kfWeChat: cdn + '/img/kfWeChat.png',
  },
  files: {

  }
}
export default config



// WEBPACK FOOTER //
// ./src/config/oem/config_xinyuan.js